import React, { useState, useEffect } from 'react';
import { API_DOMAIN } from './globals'; // Import the global domain name

function Logout() {

    const [loading, setLoading] = useState(true);  // Loading state
    const [error, setError] = useState(null);  // Error state

    useEffect(() => {
        const param1 = sessionStorage.getItem("UserType");
        const param2 = sessionStorage.getItem("UserName");

        const params = { ut: param1, un: param2 };

        const queryString = new URLSearchParams(params).toString();
        const url = `${API_DOMAIN}//Logout.php?${queryString}`;
        
        fetch(url, {
            method: 'GET',
            credentials: 'include', // Equivalent to withCredentials:true
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                console.log(data.Status);
                // if(data.Status=="Success") {
                    window.location = '/';
                // } else {
                //     //console.log(data.data);
                //     //setMyLedger(data.data); // Save the response data in state

                //     const ledgerData = data.data;
                //     setMyLedger(ledgerData);

                //     if (ledgerData.length > 0) {
                //         setTotalDebit(ledgerData[0].TotDebit);
                //         setTotalCredit(ledgerData[0].TotCredit);
                //         setBalance(-ledgerData[0].Balance);
                //         //console.log("TotDebit="+ledgerData[0].TotDebit+", TotCredit="+ledgerData[0].TotCredit+", Balance="+ledgerData[0].Balance)
                //         calculateBalance(ledgerData);
                //     }
                // }
                setLoading(false); // Set loading to false
            })
            .catch(err => {
                setError(err); // Save any error to the state
                setLoading(false); // Set loading to false
            });

    }, []);  // Empty dependency array ensures this runs only once when the component mounts

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    return (
        <>
            
        </>
    )
}

export default Logout;
